document.addEventListener("DOMContentLoaded", function () {
  window.upcartOnCartLoaded = function (cart) {
    if (!cart || cart.item_count !== 0) return;

    const customEmptyCart = document.querySelector("[data-empty-cart]");
    if (!customEmptyCart) return;

    const upcartElement = document.querySelector('#upCart');
    if (!upcartElement) return;
    
    const customEmptyCartWrapper = upcartElement.shadowRoot?.querySelector('[class*="styles_CartPreview__empty__"]');
    if (customEmptyCartWrapper) {
      customEmptyCartWrapper.innerHTML = customEmptyCart.innerHTML;
    }
  };
});